// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * Type of plugin function
 */
export enum ECpmAEPluginFunctionTypeApiEnum {
    TASK = 'TASK',
    SERVICE_REQUEST_GENERATOR = 'SERVICE_REQUEST_GENERATOR',
    AUTOMATION = 'AUTOMATION'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmAEPluginFunctionTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmAEPluginFunctionTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmAEPluginFunctionTypeApiEnum
        ])
);


// ===============================================================
// ===============================================================

/**
 * Plugin attributes 1
 */
export enum ECpmAEPluginAttributes1ApiEnum {
    NONE = 0,
    ALWAYS_ENABLED = 1,
    DEBUG_ONLY = 2
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmAEPluginAttributes1ApiEnum = Object.fromEntries(
    Object.entries(ECpmAEPluginAttributes1ApiEnum)
        .filter((x) => !x[0].toString().toUpperCase().startsWith("MASK_"))
        .filter((x) => !x[1].toString().toUpperCase().startsWith("MASK_"))
        .map(([key, value]) => [
            value,
            key as unknown as ECpmAEPluginAttributes1ApiEnum
        ])
);

